import React from "react";
import { Link } from "react-router-dom";
import { AlertCircle, ArrowRight, Loader2 } from "lucide-react";

export function PublicPageShell({ eyebrow, title, intro, children, width = "max-w-6xl" }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-blue-50/40 to-white px-4 py-12 sm:px-6 sm:py-16">
      <div className={`${width} mx-auto`}>
        <header className="mb-8 max-w-3xl sm:mb-10">
          {eyebrow ? (
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-blue-700">
              {eyebrow}
            </p>
          ) : null}
          <h1 className="text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">
            {title}
          </h1>
          {intro ? (
            <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg">{intro}</p>
          ) : null}
        </header>
        {children}
      </div>
    </div>
  );
}

export function StatusCard({
  icon: Icon = AlertCircle,
  tone = "blue",
  eyebrow,
  title,
  children,
  primary,
  secondary,
  busy = false,
}) {
  const tones = {
    blue: "bg-blue-50 text-blue-700 ring-blue-100",
    green: "bg-emerald-50 text-emerald-700 ring-emerald-100",
    red: "bg-rose-50 text-rose-700 ring-rose-100",
  };

  return (
    <section className="mx-auto max-w-2xl rounded-3xl border border-slate-200 bg-white p-6 text-center shadow-[0_18px_60px_rgba(15,23,42,0.08)] sm:p-10">
      <div className={`mx-auto flex h-14 w-14 items-center justify-center rounded-2xl ring-8 ${tones[tone]}`}>
        {busy ? <Loader2 className="h-7 w-7 animate-spin" aria-hidden="true" /> : <Icon className="h-7 w-7" aria-hidden="true" />}
      </div>
      {eyebrow ? <p className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-blue-700">{eyebrow}</p> : null}
      <h1 className="mt-3 text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">{title}</h1>
      <div className="mx-auto mt-4 max-w-xl text-base leading-7 text-slate-600">{children}</div>
      {(primary || secondary) ? (
        <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
          {primary ? (
            <Link to={primary.to} className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-blue-500/20 transition hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-blue-200">
              {primary.label}<ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          ) : null}
          {secondary ? (
            <Link to={secondary.to} className="inline-flex min-h-11 items-center justify-center rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 transition hover:border-blue-200 hover:text-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-100">
              {secondary.label}
            </Link>
          ) : null}
        </div>
      ) : null}
    </section>
  );
}
